import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import appConfig from '../../../../app-config';
import { useSelector } from 'react-redux';
import { PrimaryButton } from '../../../components/Buttons';
const Wrapper = styled.div``;
const Title = styled.div`
  font-size: 32px;
  text-transform: uppercase;
  font-weight: 600;
`;
const Message = styled.div`
  font-size: 18px;
`;
const ActionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: ${(props) => props.marginTop || '30px'};
`;
const LinkCardButton = styled(PrimaryButton)`
  padding: 19px 16px 19px 24px;
  font-size: 19px;
  font-weight: 600;
  text-transform: uppercase;
  &:hover {
    transition: all 0.25s ease;
  }
`;
const LoyaltyCardImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
`;
export const LoyaltyCreateNewCard = ({ handleCloseModal }) => {
  const { requestingNewDigitalCard } = useSelector(
    (state) => state.loyaltyReducer
  );
  return (
    <Wrapper>
      <>
        <LoyaltyCardImageContainer>
          <img
            src={appConfig.styleConfig.loyaltyCardImage}
            alt='a man with a cowboy hat'
          />
        </LoyaltyCardImageContainer>
        {!requestingNewDigitalCard && (
          <ActionWrapper marginTop='100px'>
            <LinkCardButton
              id='ExistingGiftCard-AddGiftCard'
              type='submit'
              onClick={handleCloseModal}
            >
              Start Earning Rewards
            </LinkCardButton>
          </ActionWrapper>
        )}
      </>
    </Wrapper>
  );
};
